export default {
  // Page Title and Actions
  backToDashboard: 'Back to Dashboard',
  shareCareInstructions: 'Share Care Instructions',
  edit: 'Edit',
  preview: 'Preview',
  
  // Empty State
  petNotFound: 'Pet Not Found',
  petNotFoundDesc: 'This pet may have been deleted or does not exist',
  
  // Basic Info
  basicInfo: 'Basic Info',
  unnamedPet: 'Unnamed Pet',
  notSpecified: 'Not Specified',
  unknown: 'Unknown',
  notSet: 'Not Set',
  
  // Type and Gender
  type: 'Type',
  breed: 'Breed',
  age: 'Age',
  birthDate: 'Birth Date',
  gender: 'Gender',
  male: 'Male',
  female: 'Female',
  weight: 'Weight',
  height: 'Height',
  color: 'Color',
  coatType: 'Coat Type',
  eyeColor: 'Eye Color',
  bodySize: 'Body Size',
  specialMarkings: 'Special Markings',
  microchipId: 'Microchip ID',
  registrationId: 'Registration ID',
  currentLocation: 'Current Location',
  
  // Time Units
  year: 'year',
  years: 'years',
  month: 'month',
  months: 'months',
  
  // Section Titles
  physicalTraits: 'Physical Traits',
  dietaryInfo: 'Dietary Info',
  behaviorInfo: 'Behavior Info',
  healthInfo: 'Health Info',
  veterinarianInfo: 'Veterinarian Info',
  specialNotes: 'Special Notes',
  
  // Dietary Related
  feedingSchedule: 'Feeding Schedule',
  nextFeeding: 'Next Feeding',
  canEat: 'Can Eat',
  cannotEat: 'Cannot Eat',
  breakfast: 'Breakfast',
  lunch: 'Lunch',
  dinner: 'Dinner',
  snack: 'Snack',
  portionSize: 'Portion Size',
  foodType: 'Food Type',
  time: 'Time',
  
  // Behavior Related
  temperament: 'Temperament',
  likes: 'Likes',
  dislikes: 'Dislikes',
  exerciseNeeds: 'Exercise Needs',
  trainingNotes: 'Training Notes',
  
  // Health Related
  medicationSchedule: 'Medication Schedule',
  nextMedication: 'Next Medication',
  medications: 'Medications',
  medicationName: 'Medication Name',
  dosage: 'Dosage',
  frequency: 'Frequency',
  daily: 'Daily',
  twiceDaily: 'Twice Daily',
  thriceDaily: 'Thrice Daily',
  weekly: 'Weekly',
  monthly: 'Monthly',
  custom: 'Custom',
  morningMeds: 'Morning Meds',
  afternoonMeds: 'Afternoon Meds',
  eveningMeds: 'Evening Meds',
  nightMeds: 'Night Meds',
  vaccines: 'Vaccines',
  nextVaccineDate: 'Next Vaccine Date',
  nextVetVisit: 'Next Vet Visit',
  allergies: 'Allergies',
  medicalConditions: 'Medical Conditions',
  
  // Veterinarian Info
  vetName: 'Vet Clinic',
  vetPhone: 'Vet Phone',
  vetAddress: 'Vet Address',
  vetEmail: 'Vet Email',
  insuranceProvider: 'Insurance Provider',
  insurancePolicy: 'Policy Number',
  
  // Loading State
  loadingPet: 'Loading pet data...',
  
  // Not Filled State
  notFilled: 'Not Filled',
  home: 'Home',
};